{
  "info": "Informacje",
  "negative": "Błąd",
  "positive": "Powodzenie"
}
